import { cn } from '@/shared/lib/cn';
import { type MeterTone, meterFillVariants } from './meter-variants';

type MeterProps = {
  /** 0 to 1; values outside are clamped. */
  ratio: number;
  tone?: MeterTone;
  /** Names the meter for screen readers; without it the meter is decoration next to visible numbers. */
  label?: string;
  className?: string;
};

export function Meter({ ratio, tone, label, className }: MeterProps) {
  const percent = Math.min(1, Math.max(0, ratio)) * 100;
  const fill = (
    <i data-meter="" className={meterFillVariants({ tone })} style={{ width: `${percent}%` }} />
  );
  const classes = cn('h-2 overflow-hidden rounded-meter bg-surface-3', className);
  if (!label) {
    return (
      <div data-slot="meter" aria-hidden="true" className={classes}>
        {fill}
      </div>
    );
  }
  return (
    // biome-ignore lint/a11y/useSemanticElements: a native <meter> cannot hold the fill GSAP animates.
    <div
      data-slot="meter"
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(percent)}
      className={classes}
    >
      {fill}
    </div>
  );
}
